import { useCallback, useEffect, useMemo, useState } from "react";
import { Title, Button, Layout, useToast } from "@introist/react-foundation/v2";

import { TextInput } from "components/atoms";

import { updateIntegrationConfiguration, useIntegrationsApi } from "services/api/IntegrationsApi";

type FreshServiceConfiguration = {
  domain: string;
};

type FreshServiceConfigurationContainerProps = {
  integrationId: string;
};

export const FreshServiceConfigurationContainer = ({
  integrationId
}: FreshServiceConfigurationContainerProps) => {
  const toast = useToast();

  const integrationApi = useIntegrationsApi();
  const findIntegration = integrationApi.find({ integrationId });
  const { data: integration } = findIntegration.query;

  const [domain, setDomain] = useState("");

  useEffect(() => {
    setDomain((integration?.configuration as FreshServiceConfiguration)?.domain ?? "");
  }, [integration]);

  const domainChanged = useMemo(() => {
    if (!integration) return false;
    return domain !== (integration?.configuration as FreshServiceConfiguration)?.domain;
  }, [integration, domain]);

  const onSave = useCallback(async () => {
    await updateIntegrationConfiguration({ integrationId, configuration: { domain } })
      .then(async () => {
        await findIntegration.refetch();
        toast.success("Configuration updated");
      })
      .catch(() => toast.error("Failed to update configuration"));
  }, [integrationId, domain, findIntegration, toast]);

  return (
    <Layout.Group vertical lastChildToEnd gap="xLarge">
      <TextInput
        label="FreshService domain"
        type="text"
        value={domain}
        onChange={newVal => {
          setDomain(newVal);
        }}
        endAdornment={<Title>.freshservice.com</Title>}
      />
      <Button disabled={!domainChanged} onClickWithLoading={onSave}>
        Save
      </Button>
    </Layout.Group>
  );
};
